import React from "react";
import Header from "./Header";
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isHeaderActive, setIsHeaderActive] = useState(false);
  const [isResponsive, setIsResponsive] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  let userName= localStorage.getItem("currentUser");
  let supplierName= localStorage.getItem("supplierName");
  const [isStatementActive, setIsStatementActive] = useState(false);
  const adminLinks = [
    {
      path: "/Home",
      label: "HOME",
    },
    {
      path: "/Profile",
      label: "PROFILE",
    },
    {
      path: "/AppField",
      label: "APP FIELD",
    },
    {
      path: "/Documents",
      label: "DOCUMENTS",
    },
    {
      path: "/Charts",
      label: "CHARTS",
    },
    {
      path: "/Forecast",
      label: "FORECAST",
    },
    {
      path: "/Notes",
      label: "NOTES",
    },
  ];
  const userLinks = [
    {
      path: "/Home",
      label: "HOME",
    },
    {
      path: "/Statement",
      label: isStatementActive ? "STATEMENT" : "STATEMENT",
    },
    {
      path: "/Documents",
      label: "DOCUMENTS",
    },
    {
      path: "/Charts",
      label: "CHARTS",
    },
    {
      path: "/Forecast",
      label: "FORECAST",
    },
  ];
  useEffect(() => {
    setIsStatementActive(location.pathname === "/Statement");
  }, [location]);
  useEffect(() => {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");
    if (token) {
      const userRole = role;;
      setIsAdmin(userRole && userRole.toLowerCase().includes("admin"));
    } else {
      console.error("Token not found in localStorage.");
    }
  }, []);

  const navLinks = isAdmin ? adminLinks : userLinks;

  const handleMyFunction = () => {
    const x = document.getElementById("myTopnav");
    x.className = isResponsive ? "topnav" : "topnav responsive";
    setIsResponsive((prevState) => !prevState);
  };

  const handleTopnavClick = () => {
    setIsHeaderActive((prevState) => !prevState);
  };
  const handleLogout = () => {
    localStorage.clear("token", "supplierId");
    // sessionStorage.removeItem("token", "supplierId");
    setIsAdmin(false);
    const { protocol, host } = window.location;
    window.location.href = `${protocol}//${host}/`;
  };
  const handleStatementClick = () => {
    setIsStatementActive(!isStatementActive);
    navigate(isStatementActive ? "" : "/Statement");
  };
  return (
    <div id="header-wrapper" className={isHeaderActive ? "activeHeader" : ""}>
      <Header />
      {isAdmin ? (
        <div id="user">
          <span className="tabfull">
            <a>
              Shows <span className="Viewing-cap">{supplierName||"Joe Bloggs "}</span>
              ID {userName||'0041500'}
            </a>
          </span>
        </div>
      ) : (
        <div id="user"><span className="tabfull"></span></div>
      )}
      <div id="main-nav">
        <div className="topnav" id="myTopnav">
          <a
            className="icon"
            hidden
            onClick={() => {
              handleTopnavClick();
              handleMyFunction();
            }}
          >
            <div className="nav-item">
              <h3>Menu</h3>
            </div>
          </a>
          <ul className="sidebar-menu">
            {navLinks.map((link) => (
              <li
                key={link.label}
                controllername={link.controllername}
                onClick={
                  link.path === "/Statement"
                    ? handleStatementClick
                    : () => navigate(link.path)
                }
              >
                <a>
                  <span>
                    {link.path === "/Statement"
                      ? isStatementActive
                        ? "STATEMENT"
                        : "STATEMENT"
                      : link.label}
                  </span>
                </a>
              </li>
            ))}
            <li onClick={handleLogout}>
              <a>
                <span>EXIT</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
